import React from "react";
import { Typography, Grid } from "@mui/material";
import DataField from "../Datafield";
import MappedText from "../../reports/create-report/shared-components/mapText";
import { convertDate } from "../../reports/create-report/sections/utils";



export default function ClinicalInfo({ allDataApis }) {
    return (
      <>
        <Typography variant={"h5"} style={{ fontWeight: "700", marginBottom: "20px" }}>
          <MappedText text={"Clinical Info"} />
        </Typography>
  
        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Clinical referral"
              value={allDataApis?.participants?.[0]?.referral || "NA"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Observed Symptoms"
              value={
                allDataApis?.participants?.[0]?.features
                  ?.filter((feature) => feature.observed === true)
                  .map((feature) => feature.name)
                  .join(", ") || "NA"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Diagnostic date"
              value={
                
                  allDataApis?.participants?.[0]?.diagnosis?.[0]?.diagnosis_date
                 || "NA"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Clinical diagnosis"
              value={
                allDataApis?.participants?.[0]?.diagnosis?.[0]?.ordo.name || "NA"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Case number pathology"
              value={
                allDataApis?.participants?.[0]?.case_number_pathology || "NA"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Treatment history and response"
              value={`${allDataApis?.participants?.[0]?.treatmenthistory}, ${
                allDataApis?.participants?.[0]?.treatment_response
              }`}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Cancer type"
              value={allDataApis?.participants?.[0]?.cancer_type || "NA"}
            />
          </Grid>
        </Grid>
      </>
    );
  }
  